/* eslint-disable no-param-reassign */
import { Component } from 'react'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import Psfs from 'lib/psfs/Psfs'
import {
  fetchFilters,
  setInitReadyState,
  setInitFilters,
  setFilters,
  setActiveFilter,
} from 'reducers/myJobsDataViewer/action'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import { siteFetchList } from 'reducers/site/reducer'
import withPromise from 'helpers/withPromise'
import { INPUT_FIELD_TYPES } from 'helpers/input'
import { createMyJobDataViewFilters } from 'helpers/myJobs'

class InitFilterData extends Component {
  componentDidMount() {
    const { siteFetchList } = this.props
    const psfs = new Psfs()
    psfs.addFilter('active', 1)
    psfs.addFilter('visibleInUi', 1)
    psfs.addFields(['id', 'name'])

    withPromise(siteFetchList, {
      isOnlyPromiseExec: true,
      psfs,
    }).then(this.fetchFilters)
  }

  componentDidUpdate(prevProps) {
    const {
      setInitReadyState,
      activeDateRange: prevActiveDateRange,
      siteFilter: prevSiteFilter,
      jobsFilter: prevJobsFilter,
      jobTasksFilter: prevJobTasksFilter,
      jobInputsFilter: prevJobInputsFilter,
      jobInputTypesFilter: prevJobInputTypesFilter,
      locusGroupsFilter: prevLocusGroupsFilter,
      locusesFilter: prevLocusesFilter,
    } = prevProps
    const {
      siteList,
      initReady,
      activeDateRange,
      siteFilter,
      jobsFilter,
      jobTasksFilter,
      jobInputsFilter,
      jobInputTypesFilter,
      locusGroupsFilter,
      locusesFilter,
    } = this.props

    const { start, end } = activeDateRange.toJS()
    const { start: prevStart, end: prevEnd } = prevActiveDateRange.toJS()

    if (initReady) {
      if (
        siteFilter !== prevSiteFilter ||
        start.format('YYYY-MM-DD') !== prevStart.format('YYYY-MM-DD') ||
        end.format('YYYY-MM-DD') !== prevEnd.format('YYYY-MM-DD')
      ) {
        this.fetchFilters(siteList.toArray())
      }

      if (jobsFilter !== prevJobsFilter) {
        this.shouldActiveFiltersUpdate(this.props, this.checkJobsFilters)
      }

      if (jobTasksFilter !== prevJobTasksFilter) {
        this.shouldActiveFiltersUpdate(this.props, this.checkTasksFilters)
      }

      if (jobInputsFilter !== prevJobInputsFilter) {
        this.shouldActiveFiltersUpdate(this.props, this.checkInputsFilters)
      }

      if (
        jobInputTypesFilter !== prevJobInputTypesFilter ||
        locusGroupsFilter !== prevLocusGroupsFilter ||
        locusesFilter !== prevLocusesFilter
      ) {
        setInitReadyState(false)
        queueMicrotask(() => setInitReadyState(true))
      }
    }
  }

  getInitFiltersLists = filters => ({
    jobs: [...filters.jobs],
    tasks: [...filters.job_tasks],
    inputs: [...filters.job_inputs],
    inputTypes: [...filters.job_input_types],
    unitGroups: [...filters.locus_groups],
    units: [...filters.locuses],
  })

  getInitProfileFilters = (activeSiteId, props) => {
    const {
      jobsFilter,
      jobTasksFilter,
      jobInputsFilter,
      jobInputTypesFilter,
      locusGroupsFilter,
      locusesFilter,
    } = props

    return {
      site: activeSiteId,
      jobs: jobsFilter.toArray(),
      jobTasks: jobTasksFilter.toArray(),
      jobInputs: jobInputsFilter.toArray(),
      jobInputTypes: jobInputTypesFilter.toArray(),
      locusGroups: locusGroupsFilter.toArray(),
      locuses: locusesFilter.toArray(),
    }
  }

  getActualProfileFilters = (filterValues, isClone) => ({
    site: filterValues.site,
    jobs: isClone ? [...filterValues.jobs] : filterValues.jobs,
    jobTasks: isClone ? [...filterValues.jobTasks] : filterValues.jobTasks,
    jobInputs: isClone ? [...filterValues.jobInputs] : filterValues.jobInputs,
    jobInputTypes: isClone
      ? [...filterValues.jobInputTypes]
      : filterValues.jobInputTypes,
    locusGroups: isClone
      ? [...filterValues.locusGroups]
      : filterValues.locusGroups,
    locuses: isClone ? [...filterValues.locuses] : filterValues.locuses,
  })

  getActiveFilterInList = (activeFilterList, list) => {
    const checkMap = activeFilterList.reduce((map, id) => {
      map[id] = true

      return map
    }, {})

    return list
      .filter(item => Object.prototype.hasOwnProperty.call(checkMap, item.id))
      .map(item => item.id)
  }

  getFilteredList = (list, filters, filterField) => {
    const filterMap = filters.reduce((map, key) => {
      map[key] = true

      return map
    }, {})

    return list.filter(item => {
      const field = item[filterField]

      if (Array.isArray(field)) {
        return field.find(key =>
          Object.prototype.hasOwnProperty.call(filterMap, key),
        )
      }

      return Object.prototype.hasOwnProperty.call(filterMap, field)
    })
  }

  checkJobsFilters = (
    initFiltersLists,
    initFiltersValues,
    resultFiltersLists,
    resultFiltersValues,
  ) => {
    const {
      tasks: tasksList,
      unitGroups: unitGroupsList,
      units: unitsList,
    } = initFiltersLists
    const { jobs: jobsValues } = initFiltersValues

    resultFiltersLists.jobs = [...initFiltersLists.jobs]

    if (jobsValues.length && jobsValues[0] !== -1) {
      const nextJobsValues = this.getActiveFilterInList(
        jobsValues,
        resultFiltersLists.jobs,
      )

      // сетим новые значения для профиль фильтра jobs
      if (!isEqual(jobsValues, nextJobsValues)) {
        resultFiltersValues.jobs = nextJobsValues
      }

      if (nextJobsValues.length) {
        resultFiltersLists.unitGroups = this.getFilteredList(
          unitGroupsList,
          nextJobsValues,
          'job_ids',
        )
        resultFiltersLists.units = this.getFilteredList(
          unitsList,
          nextJobsValues,
          'job_ids',
        )
        resultFiltersLists.tasks = this.getFilteredList(
          tasksList,
          nextJobsValues,
          'job_id',
        )
      } else {
        resultFiltersLists.unitGroups = unitGroupsList
        resultFiltersLists.units = unitsList
        resultFiltersLists.tasks = tasksList
      }
    } else {
      resultFiltersLists.unitGroups = unitGroupsList
      resultFiltersLists.units = unitsList
      resultFiltersLists.tasks = tasksList
    }

    this.checkLocusGroupsFilters(
      initFiltersLists,
      initFiltersValues,
      resultFiltersLists,
      resultFiltersValues,
    )
    this.checkLocusFilters(
      initFiltersLists,
      initFiltersValues,
      resultFiltersLists,
      resultFiltersValues,
    )
    this.checkTasksFilters(
      initFiltersLists,
      initFiltersValues,
      resultFiltersLists,
      resultFiltersValues,
    )
  }

  checkLocusGroupsFilters = (
    initFiltersLists,
    initFiltersValues,
    resultFiltersLists,
    resultFiltersValues,
  ) => {
    const { locusGroups: unitGroupsValues } = initFiltersValues

    if (unitGroupsValues.length && unitGroupsValues[0] !== -1) {
      const nextUnitGroupsValues = this.getActiveFilterInList(
        unitGroupsValues,
        resultFiltersLists.unitGroups,
      )

      // сетим новые значения для профиль фильтра jobInputs
      if (!isEqual(unitGroupsValues, nextUnitGroupsValues)) {
        resultFiltersValues.locusGroups = nextUnitGroupsValues
      }
    }
  }

  checkLocusFilters = (
    initFiltersLists,
    initFiltersValues,
    resultFiltersLists,
    resultFiltersValues,
  ) => {
    const { locuses: unitsValues } = initFiltersValues

    if (unitsValues.length && unitsValues[0] !== -1) {
      const nextUnitsValues = this.getActiveFilterInList(
        unitsValues,
        resultFiltersLists.units,
      )

      // сетим новые значения для профиль фильтра jobInputTypes
      if (!isEqual(unitsValues, nextUnitsValues)) {
        resultFiltersValues.locuses = nextUnitsValues
      }
    }
  }

  checkTasksFilters = (
    initFiltersLists,
    initFiltersValues,
    resultFiltersLists,
    resultFiltersValues,
  ) => {
    const { inputs: inputsList } = initFiltersLists
    const { jobTasks: jobTasksValues } = initFiltersValues
    const {
      tasks: tasksList = this.props.tasksList.toArray(),
    } = resultFiltersLists
    const isOriginList = initFiltersLists.tasks.length === tasksList.length

    if (jobTasksValues.length && jobTasksValues[0] !== -1) {
      const nextJobTasksValues = this.getActiveFilterInList(
        jobTasksValues,
        tasksList,
      )

      // сетим новые значения для профиль фильтра tasks
      if (!isEqual(jobTasksValues, nextJobTasksValues)) {
        resultFiltersValues.jobTasks = nextJobTasksValues
      }

      if (nextJobTasksValues.length) {
        resultFiltersLists.inputs = this.getFilteredList(
          inputsList,
          nextJobTasksValues,
          'task_id',
        )
      } else {
        resultFiltersLists.inputs = isOriginList
          ? inputsList
          : this.getFilteredList(
              inputsList,
              tasksList.map(item => item.id),
              'task_id',
            )
      }
    } else {
      resultFiltersLists.inputs = isOriginList
        ? inputsList
        : this.getFilteredList(
            inputsList,
            tasksList.map(item => item.id),
            'task_id',
          )
    }

    this.checkInputsFilters(
      initFiltersLists,
      initFiltersValues,
      resultFiltersLists,
      resultFiltersValues,
    )
  }

  checkInputsFilters = (
    initFiltersLists,
    initFiltersValues,
    resultFiltersLists,
    resultFiltersValues,
  ) => {
    const { inputTypes: inputTypesList } = initFiltersLists
    const { jobInputs: jobInputsValues } = initFiltersValues
    const {
      inputs: inputsList = this.props.inputsList.toArray(),
    } = resultFiltersLists
    const isOriginList = initFiltersLists.inputs.length === inputsList.length

    if (jobInputsValues.length && jobInputsValues[0] !== -1) {
      const nextJobInputsValues = this.getActiveFilterInList(
        jobInputsValues,
        inputsList,
      )

      // сетим новые значения для профиль фильтра jobInputs
      if (!isEqual(jobInputsValues, nextJobInputsValues)) {
        resultFiltersValues.jobInputs = nextJobInputsValues
      }

      if (nextJobInputsValues.length) {
        resultFiltersLists.inputTypes = this.getFilteredList(
          inputTypesList,
          nextJobInputsValues,
          'input_ids',
        )
      } else {
        resultFiltersLists.inputTypes = isOriginList
          ? inputTypesList
          : this.getFilteredList(
              inputTypesList,
              inputsList.map(item => item.id),
              'input_ids',
            )
      }
    } else {
      resultFiltersLists.inputTypes = isOriginList
        ? inputTypesList
        : this.getFilteredList(
            inputTypesList,
            inputsList.map(item => item.id),
            'input_ids',
          )
    }

    this.checkInputTypesFilters(
      initFiltersLists,
      initFiltersValues,
      resultFiltersLists,
      resultFiltersValues,
    )
  }

  checkInputTypesFilters = (
    initFiltersLists,
    initFiltersValues,
    resultFiltersLists,
    resultFiltersValues,
  ) => {
    const { jobInputTypes: jobInputTypesValues } = initFiltersValues

    if (jobInputTypesValues.length && jobInputTypesValues[0] !== -1) {
      const nextJobInputTypesValues = this.getActiveFilterInList(
        jobInputTypesValues,
        resultFiltersLists.inputTypes,
      )

      // сетим новые значения для профиль фильтра jobInputTypes
      if (!isEqual(jobInputTypesValues, nextJobInputTypesValues)) {
        resultFiltersValues.jobInputTypes = nextJobInputTypesValues
      }
    }
  }

  fetchFilters = siteList => {
    const {
      activeDateRange,
      siteFilter,
      fetchFilters,
      setInitReadyState,
    } = this.props
    const existingActiveSite = siteList.find(item => item.id === siteFilter)
    const activeSite = existingActiveSite || siteList[0]

    setInitReadyState(false)

    withPromise(fetchFilters, {
      query: {
        site: activeSite.id,
        from: activeDateRange.get('start').format('YYYY-MM-DD'),
        to: activeDateRange.get('end').format('YYYY-MM-DD'),
      },
    }).then(filters => {
      const {
        setInitFilters,
        setFilters,
        setMyJobsDataViewerFilter,
      } = this.props

      // заполняем массив input_types именами по текущей локализации
      filters.job_input_types.forEach(item => {
        item.name = INPUT_FIELD_TYPES[item.id]
      })

      // сохраняем исходные фильтра в стору на будущее
      setInitFilters(filters)

      // инициализируем данные для будущего сравнения перед сохранением
      const initProfileFilters = this.getInitProfileFilters(
        siteFilter,
        this.props,
      )
      const initFiltersLists = this.getInitFiltersLists(filters)

      // добавляем сайты в фильтра чтобы засетить их
      initFiltersLists.sites = siteList

      // чекаем - изменился ли активный сайт по отношению к пользовательским фильтрам;
      const isChangedActiveSite = existingActiveSite !== activeSite

      // инициализируем данные для последующего пересета
      let profileFilters = {}
      let filtersLists = {
        sites: siteList,
      }

      if (isChangedActiveSite) {
        filtersLists = initFiltersLists
        profileFilters = this.getActualProfileFilters(
          Object.assign(createMyJobDataViewFilters(), { site: activeSite.id }),
        )
      } else {
        this.checkJobsFilters(
          initFiltersLists,
          this.getActualProfileFilters(initProfileFilters, true),
          filtersLists,
          profileFilters,
        )
      }

      // проверяем появились ли пользоватьельские фильтра для перезаписи
      if (Object.keys(profileFilters).length) {
        // сетим новые значения пользовательских фильтров
        setMyJobsDataViewerFilter(profileFilters)
      }
      // сетим списки фильтров
      setFilters(filtersLists)

      // оповещаем приложение о завершении изменений
      queueMicrotask(() => setInitReadyState(true))
    })
  }

  shouldActiveFiltersUpdate = (props, checkFiltersFunction) => {
    const {
      siteFilter,
      initFilters,
      setInitReadyState,
      setMyJobsDataViewerFilter,
      setFilters,
    } = props
    const initFiltersLists = this.getInitFiltersLists(initFilters.toJS())
    const initProfileFilters = this.getInitProfileFilters(siteFilter, props)
    const profileFilters = {}
    const filtersLists = {}

    setInitReadyState(false)
    checkFiltersFunction(
      initFiltersLists,
      initProfileFilters,
      filtersLists,
      profileFilters,
    )

    if (Object.keys(profileFilters).length) {
      setMyJobsDataViewerFilter(profileFilters)
    }

    setFilters(filtersLists)
    queueMicrotask(() => setInitReadyState(true))
  }

  render() {
    return null
  }
}

export default connect(
  store => ({
    initReady: store.getIn(['myJobsDataViewer', 'isInitReady']),
    activeSite: store.getIn(['myJobsDataViewer', 'activeSite']),
    activeDateRange: store.getIn(['myJobsDataViewer', 'activeDateRange']),
    siteFilter: store.getIn(['profile', 'jobsDataViewerFilters', 'site']),
    jobsFilter: store.getIn(['profile', 'jobsDataViewerFilters', 'jobs']),
    jobTasksFilter: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'jobTasks',
    ]),
    jobInputsFilter: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'jobInputs',
    ]),
    jobInputTypesFilter: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'jobInputTypes',
    ]),
    locusGroupsFilter: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'locusGroups',
    ]),
    locusesFilter: store.getIn(['profile', 'jobsDataViewerFilters', 'locuses']),
    siteList: store.getIn(['myJobsDataViewer', 'filters', 'sites']),
    tasksList: store.getIn(['myJobsDataViewer', 'filters', 'tasks']),
    inputsList: store.getIn(['myJobsDataViewer', 'filters', 'inputs']),
    initFilters: store.getIn(['myJobsDataViewer', 'initFilters']),
    filters: store.getIn(['myJobsDataViewer', 'filters']),
  }),
  {
    siteFetchList,
    fetchFilters,
    setFilters,
    setInitFilters,
    setActiveFilter,
    setMyJobsDataViewerFilter,
    setInitReadyState,
  },
)(InitFilterData)
